__turbopack_context__.v({
  "grid": "common-module__5NDDJG__grid",
  "gridItems": "common-module__5NDDJG__gridItems",
  "iconBox": "common-module__5NDDJG__iconBox",
  "mainOuter": "common-module__5NDDJG__mainOuter",
  "sectionTitle": "common-module__5NDDJG__sectionTitle",
  "subGrid": "common-module__5NDDJG__subGrid",
  "subGridItems": "common-module__5NDDJG__subGridItems",
});
